// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./scss/calia.scss
// module id = 1367
// module chunks = 172